import { getDifficultyLabel } from 'utils/functions/IdeaLab/getDifficultyLabel'

import s from './KeywordDifficulty.module.css'

type Props = {
  difficulty: number
}

export const KeywordDifficulty = ({ difficulty }: Props) => {
  const level = getDifficultyLabel(difficulty)

  return (
    <div className={s[level.toLowerCase()]}>
      <div className={s.level}>{level}</div>
      <span className={s.dot}>•</span>
      <div className={s.percent}>{difficulty}%</div>
    </div>
  )
}
